import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isChirpEnabled } from '../../../utils/isChirpEnabled';
import { trackInteraction } from '../../../tracking/tracker';
import { CLICK_DOWNLOAD } from '../../../tracking/actions';
import { ButtonWithBranding } from '../../ButtonWithBranding';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ViewToolbarDownloadButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleDownloadClick = () => {
      const {
        presentation,
        sharedLink,
        fetchDownloadLink
      } = this.props;
      const isUngatedToChirp = isChirpEnabled();
      const id = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id : presentation === null || presentation === void 0 ? void 0 : presentation.id;
      if (!id) return;
      trackInteraction(CLICK_DOWNLOAD);
      fetchDownloadLink(id).then(downloadUrl => {
        window.location = downloadUrl;
      }).catch(err => {
        console.error(err);
      });
    };
  }
  render() {
    const {
      brandingColor
    } = this.props;
    return /*#__PURE__*/_jsx(ButtonWithBranding, {
      marginInlineStart: "300",
      marginInlineEnd: "800",
      brandingColor: brandingColor,
      onClick: this.handleDownloadClick,
      "aria-label": I18n.text('a11y.downloadButton'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "view.toolbar.download"
      })
    });
  }
}